import img from "../src/img/1.png";
import img2 from "../src/img/17.png";
import img3 from "../src/img/10.png";
import img4 from "../src/img/5.png";
import img5 from "../src/img/3.png";
import img6 from "../src/img/7.png";
import img7 from "../src/img/6.png";

export const sliderItems = [
  {
    id: 1,
    img: img,
    title: "Problem równości klas P i NP",
    em: "(1971)",
    desc: "czy wszystkie pytania, na które odpowiedź – jeśli się ją zna – można zweryfikować w czasie t, rozwiązanie – bez znajomości  odpowiedzi – zabierze tyle samo czasu t (mierzonego poprzez       złożoność obliczeniową)?",
    bg: "f5fafd",
    button:
      "Nierozwiązany. Wielokrotnie przedstawiano próby jej udowodnienia, jak i obalenia, a także wykazania niedowodliwości.",
  },
  {
    id: 2,
    img: img2,
    title: "Hipoteza o cyklach Hodge'a",
    em: "(1950)",
    desc: "czy na algebraicznych rozmaitościach rzutowych każdy cykl Hodge'a jest wymierną liniową kombinacją cykli algebraicznych? Hipoteza dotyczy algebraiczności wybranych klas kohomologii de Rhama.",
    bg: "fcf1ed",
    button: "Rozwiązany dla niektórych wersji.",
  },
  {
    id: 3,
    img: img3,
    title: "Hipoteza Poincarégo",
    em: "(1904)",
    desc: "każda trójwymiarowa zwarta i jednospójna rozmaitość topologiczna bez brzegu jest homeomorficzna ze sferą trójwymiarową.",
    bg: "fbf0f4",
    button:
      "Ostatecznie potwierdzona w 2003 roku przez Grigorija Perelmana. Jego prace zweryfikowano w 2006 roku.",
  },
  {
    id: 4,
    img: img4,
    title: "Hipoteza Riemanna",
    em: "(1859)",
    desc: "część rzeczywista każdego nietrywialnego zera funkcji dzeta jest równa ½.",
    bg: "f5fafd",
    button:
      "Nierozwiązany. Przedstawiono wiele argumentów za jej poprawnością.",
  },
  {
    id: 5,
    img: img5,
    title: "Równania kwantowej teorii Yanga-Millsa",
    em: "(1954)",
    desc: "próba opisania jednym formalizmem matematycznym oddziaływania słabego, silnego i elektromagnetycznego.",
    bg: "fcf1ed",
    button:
      "Nierozwiązany. Powstało wiele nowszych i bardziej skomplikowanych potencjalnych teorii tego typu.",
  },
  {
    id: 6,
    img: img6,
    title: "Równania Naviera-Stokesa",
    em: "(1822)",
    desc: "rozwiązania tych równań dla najbardziej skomplikowanych zjawisk hydrodynamicznych.",
    bg: "fbf0f4",
    button:
      "Istnieją wyniki w szczególnych przypadkach. Brak pełnego rozwiązania.",
  },
  {
    id: 7,
    img: img7,
    title: "Problem Bircha i Swinnertona-Dyera",
    em: "(1960)",
    desc: "związany z przewidywaniem rozwiązywalności pewnych równań diofantycznych związanych z krzywymi eliptycznymi.",
    bg: "f5fafd",
    button: "Rozwiązany dla niektórych wersji.",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "SHIRT STYLE!",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "LOUNGEWEAR LOVE",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "LIGHT JACKETS",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 2,
    img: "https://cdn.shopify.com/s/files/1/0101/4832/products/Angela_Natural_Tee.png?v=1606780388",
  },
  {
    id: 3,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
  },
  {
    id: 4,
    img: "https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
  },
  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 7,
    img: "https://www.vintageindustries.nl/download_front/qympzk1762/2217_Arrow_Jacket_Forest.png",
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
];
